<template>
  <div class="col-2">
    <q-btn-group
      outline
      class="mt-5 flex-column justify-content-center w-100"
    >
      <q-btn
        size="xl"
        no-caps
        :color="!active ? 'primary' : ''"
        label="All"
        @click="setFilter(null)"
      />
      <q-btn
        v-for="(category, index) in categories"
        :key="index + category"
        size="xl"
        no-caps
        :color="active === category ? 'primary' : ''"
        :label="getCategoryLabel(category)"
        @click="setFilter(category)"
      />
    </q-btn-group>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from '../utils/CapitalizeFirstLetter';

export default {
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      categories: [],
      active: '',
    };
  },
  created() {
    this.createCategoriesList();
  },
  methods: {
    createCategoriesList() {
      const categories = [];
      this.settings.forEach((setting) => {
        if (setting.category && !categories.includes(setting.category)) {
          categories.push(setting.category);
        }
      });
      this.categories = categories;
    },
    getCategoryLabel(category) {
      const categoryLabelArray = category.split('_');
      let categoryLabel = '';
      categoryLabelArray.forEach((word) => {
        categoryLabel += categoryLabel.length > 1 ? ` ${capitalizeFirstLetter(word)}` : capitalizeFirstLetter(word);
      });
      return categoryLabel;
    },
    setFilter(category) {
      this.active = category || '';
      this.$emit('filter', category || null);
    },
  },
};
</script>
